import React from 'react';
import { motion } from 'framer-motion';
import { track, PRODUCT } from '../lib/fpixel';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  /** When true, the button goes straight to the checkout in a new tab. Otherwise it scrolls to the offer section. */
  toCheckout?: boolean;
}
const CHECKOUT_URL = 'https://glukolibreargentina.impultienda.ar/checkout';
export function Button({
  children,
  className = '',
  toCheckout = false
}: ButtonProps) {
  const baseClasses = `inline-flex items-center justify-center w-full sm:w-auto px-8 py-5 text-lg font-bold text-white bg-primary hover:bg-primary-light rounded-2xl shadow-lg transition-colors duration-300 text-center ${className}`;
  if (toCheckout) {
    const handleCheckout = () => {
      // Strong purchase-intent signal right before leaving for the checkout.
      track('InitiateCheckout', {
        content_name: PRODUCT.content_name,
        content_category: PRODUCT.content_category,
        value: PRODUCT.value,
        currency: PRODUCT.currency
      });
    };
    return <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={handleCheckout} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={baseClasses} data-id="element-21">
        {children}
      </motion.a>;
  }
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // CTA click → buyer intent, scrolls to the offer/price block.
    track('AddToCart', {
      content_name: PRODUCT.content_name,
      content_category: PRODUCT.content_category,
      value: PRODUCT.value,
      currency: PRODUCT.currency
    });
    const el = document.getElementById('oferta');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <motion.a href="#oferta" onClick={handleScroll} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={baseClasses} data-id="element-22">
      {children}
    </motion.a>;
}